import styled from 'styled-components';

export const Advantages = styled.section`
    width: 100%;
    margin-bottom: 100px;
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    @media (min-width: 620px) {
        margin: 0 auto;
        width: 600px;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-around;
    }
    @media (min-width: 980px) {
        width: 960px;
    }
`;

export const Title = styled.h2`
    margin: 0;
    margin-bottom: 50px;
    text-align: center;
    font-family: CoFoSansBold, Helvetica, sans-serif;
    font-size: 40px;
    color: #000000;
`;
